import React from 'react';

import { splitTerms } from '../../utils/notificationCopy';

/**
 * One generated sentence, with the NAMES inside it printed in ink.
 *
 * The emphasis convention is `utils/notificationCopy`'s and is described in
 * full there: a sentence — this client's or the API's — may wrap an element, a
 * card or a value in single asterisks (`When *Administration* is logged`), and
 * `splitTerms` reads exactly that and nothing else. This is the render half,
 * and it exists in one place because it was already in two: every surface that
 * prints a summary needs the same six lines, and the copies drift the moment
 * one of them grows a class name the others do not.
 *
 * ⚠ **A surface that prints a summary VERBATIM is a bug, not a degradation.**
 * Since `keepr-api utils/notifications/describe.js` started marking names, a
 * surface that did not route through here shows a reader literal asterisks —
 * which is why the audience line, the waiting-for band and the inbox's state
 * line all come through this now.
 *
 * Nothing is ever dropped: a string with no asterisks in it renders as one
 * plain segment carrying the whole sentence, so a name this build did not
 * understand still reaches the reader's eye.
 */
export default function TermText({ text, termClassName = 'notification-row__term' }) {
	return (
		<>
			{splitTerms(text).map((part, index) => (
				part.term
					? <strong key={index} className={termClassName}>{part.text}</strong>
					: <React.Fragment key={index}>{part.text}</React.Fragment>
			))}
		</>
	);
}
